module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "profiles",
    staticClass: "profiles",
    attrs: {
      "id": "brand-profiles"
    }
  }, [_c('div', {
    staticClass: "profiles__container",
    class: _vm.windowWidth <= 768 ? 'wow fadeInUp' : null,
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, _vm._l((_vm.profilesSorted), function(profile, index) {
    return _c('div', {
      key: profile.ID,
      staticClass: "profile",
      class: _vm.windowWidth > 768 && _vm.showItem ? 'fade-primary' : null,
      attrs: {
        "data-wow-delay": _vm.windowWidth > 768 && _vm.showItem ? index * 0.25 + 's' : null
      }
    }, [_c('div', {
      staticClass: "profile__image-container"
    }, [_c('img', {
      staticClass: "profile__image",
      attrs: {
        "src": profile.image.url,
        "alt": profile.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "profile__headings"
    }, [(profile.year) ? _c('h5', {
      staticClass: "label-subheading profile__date",
      domProps: {
        "textContent": _vm._s(profile.year)
      }
    }) : _vm._e(), _vm._v(" "), (profile.post_title) ? _c('h4', {
      staticClass: "heading-05 profile__name",
      domProps: {
        "textContent": _vm._s(profile.post_title)
      }
    }) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "profiles__horizontal-rule"
    })]), _vm._v(" "), (profile.description) ? _c('p', {
      staticClass: "paragraph-02 profile__copy",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(profile.description))
      }
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "paragraph-01 profile__modal-open",
      domProps: {
        "textContent": _vm._s('Learn More')
      },
      on: {
        "click": function($event) {
          _vm.activateModal(profile)
        }
      }
    })])
  })), _vm._v(" "), (_vm.modalActive) ? _c('article', {
    ref: "modal",
    staticClass: "base-modal"
  }, [_c('div', {
    staticClass: "profiles__modal"
  }, [_c('button', {
    staticClass: "profile__modal-close",
    on: {
      "click": function($event) {
        _vm.activateModal()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 23.213 23.213",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/static/graphics/modal-close.svg#modal-close'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal_headings"
  }, [_c('h5', {
    staticClass: "label-subheading profile__date",
    domProps: {
      "textContent": _vm._s(_vm.currentProfile.year)
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "heading-02 profile__modal-name",
    domProps: {
      "textContent": _vm._s(_vm.currentProfile.post_title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph-01 profile__modal-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.addComma(_vm.currentProfile.award_winners_title)) + "\n                    "), _c('span', {
    staticClass: "paragraph-01 profile__modal-organization"
  }, [_vm._v(_vm._s(_vm.currentProfile.organization))])]), _vm._v(" "), _c('hr', {
    staticClass: "profiles__horizontal-rule"
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal_image-container"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProfile.image.url),
      expression: "currentProfile.image.url"
    }],
    staticClass: "profile__image",
    attrs: {
      "src": _vm.currentProfile.image.url,
      "alt": _vm.currentProfile.image.alt === '' ? 'Photo of ' + _vm.currentProfile.post_title : _vm.currentProfile.image.alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal-copy_container"
  }, [_c('div', {
    staticClass: "paragraph-02 profile__modal_copy",
    domProps: {
      "innerHTML": _vm._s(_vm.currentProfile.description_formatted)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile__modal-navigation-container"
  }, [_c('button', {
    staticClass: "profile__modal-previous-button",
    class: _vm.currentProfileIndex === 0 ? 'profile__modal-next-button--disabled' : null,
    on: {
      "click": function($event) {
        _vm.decrementProfile()
      }
    }
  }, [_c('svg', {
    staticClass: "profile__modal-svg",
    attrs: {
      "viewBox": "0 0 8.824 15.147",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/carrot.svg#carrot'
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "profile__modal-navigation-copy",
    domProps: {
      "textContent": _vm._s('Previous')
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "profile__modal-next-button",
    class: _vm.currentProfileIndex === _vm.profiles.length - 1 ? 'profile__modal-previous-button--disabled' : null,
    on: {
      "click": function($event) {
        _vm.incrementProfile()
      }
    }
  }, [_c('p', {
    staticClass: "profile__modal-navigation-copy profile__modal-navigation-secondary",
    domProps: {
      "textContent": _vm._s('Next')
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "profile__modal-svg profile__modal-svg--rotated",
    attrs: {
      "viewBox": "0 0 8.824 15.147",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/carrot.svg#carrot'
    }
  })])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adc5b326","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandProfiles.vue
// module id = 269
// module chunks = 1